module.exports = __webpack_public_path__ + "build-assets/img/close.31b42de9.png";